import { render, staticRenderFns } from "./SvgShape.vue?vue&type=template&id=8d8a930c&scoped=true"
import script from "./SvgShape.vue?vue&type=script&lang=ts"
export * from "./SvgShape.vue?vue&type=script&lang=ts"
import style0 from "./SvgShape.vue?vue&type=style&index=0&id=8d8a930c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8a930c",
  null
  
)

export default component.exports